import { useState, type FormEvent } from 'react'
import { Outlet } from 'react-router-dom'
import '../catalog-admin.css'
import {
  clearCatalogAdminKey,
  getCatalogAdminKey,
  setCatalogAdminKey,
} from '../api/client'

export function CatalogAdminLayout() {
  const [adminKey, setAdminKeyState] = useState<string | null>(() => getCatalogAdminKey())
  const [input, setInput] = useState('')
  const [error, setError] = useState<string | null>(null)

  const handleUnlock = (event: FormEvent) => {
    event.preventDefault()
    const trimmed = input.trim()
    if (!trimmed) {
      setError('Enter the catalog admin code.')
      return
    }
    setCatalogAdminKey(trimmed)
    setAdminKeyState(trimmed)
    setError(null)
  }

  const handleLock = () => {
    clearCatalogAdminKey()
    setAdminKeyState(null)
    setInput('')
  }

  if (!adminKey) {
    return (
      <div className="debug-page catalog-admin-page">
        <header className="debug-header">
          <h1>Catalog Admin</h1>
          <p className="debug-subtitle">Enter the admin code to edit catalog compatibility data.</p>
        </header>
        <form className="catalog-unlock-form" onSubmit={handleUnlock}>
          <label htmlFor="catalog-admin-code">Admin code</label>
          <input
            id="catalog-admin-code"
            type="password"
            value={input}
            onChange={(event) => setInput(event.target.value)}
            placeholder="Catalog admin key"
            autoComplete="off"
          />
          {error ? <p className="form-error">{error}</p> : null}
          <button type="submit" className="btn-primary">
            Unlock
          </button>
        </form>
      </div>
    )
  }

  return (
    <>
      <div className="catalog-admin-toolbar">
        <span className="catalog-admin-status">Catalog admin unlocked</span>
        <button type="button" className="btn-secondary" onClick={handleLock}>
          Lock
        </button>
      </div>
      <Outlet />
    </>
  )
}
